<!--Change Password Option Modal Starts-->
<div class="modal fade auth-modal" id="change-password-option-modal" data-keyboard="false" tabindex="-1"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Login.svg" class="content-image" alt="Login">
            </div>

            <div class="col-md-7 px-4 pt-3 pb-5">
              <div class="d-flex flex-column">
                <div class="navigation-arrow mb-4" (click)="navigateToLoginModal()">
                  <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
                </div>
                <span class="title mt-5">Forgot Password</span>

                <span class="sub-title mt-4">Select which contact detail should we use to reset your password</span>

                <div class="d-flex flex-row option-card mt-4" (click)="onSelectOtpOption(otpOption.EMAIL)"
                  [ngClass]="selectedOtpOption == otpOption.EMAIL ? 'option-card-selected' : ''">
                  <i class="far fa-envelope mobile-icon mx-3 mt-3"></i>
                  <div class="d-flex flex-column">
                    <span class="header mt-3">Via email</span>
                    <span class="content-text mt-2">{{user?.userEmail}}</span>
                  </div>
                </div>

                <div class="d-flex flex-row option-card mt-3" (click)="onSelectOtpOption(otpOption.PHONE)"
                  [ngClass]="selectedOtpOption == otpOption.PHONE ? 'option-card-selected' : ''">
                  <i class="fas fa-mobile-alt mobile-icon mx-4 mt-3"></i>
                  <div class="d-flex flex-column">
                    <span class="header mt-3">Via mobile</span>
                    <span class="content-text mt-2">{{user?.userPhonenumber}}</span>
                  </div>
                </div>

                <button [disabled]="sendOtpBtn" class="btn btn-lg btn-theme mt-4 mb-5" (click)="sendPasswordOtp()">Send
                  Otp</button>
                <div *ngIf="loading" class="spinner-border loader" role="status">
                  <span class="sr-only">Loading...</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Change Password Option Modal Ends-->

<!--Verify OTP Modal Starts-->
<div class="modal fade auth-modal" id="verify-otp-modal" data-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Login.svg" class="content-image" alt="Login">
            </div>
            <div class="col-md-7 px-4 pt-3 pb-5">
              <div class="d-flex flex-column">
                <div class="navigation-arrow mb-4" (click)="chooseVerifyOptionModal()">
                  <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
                </div>
                <span class="title mt-5">Verification</span>
                <span *ngIf="this.selectedOtpOption == otpOption.EMAIL" class="sub-title-text mt-4">Please enter the 6
                  digit OTP received on your email
                  <strong>{{user?.userEmail}}</strong></span>
                <span *ngIf="this.selectedOtpOption == otpOption.PHONE" class="sub-title-text mt-4">Please enter the 6
                  digit OTP received on your phone
                  <strong>{{user?.userPhonenumber}}</strong></span>
                <span class="otp-header mt-4 mb-1">OTP</span>
                <app-otp-input #forgotPassOtp [invalidOtp]="invalidForgetPassOtp"></app-otp-input>
                <span class="no-otp-received mt-1 mb-3">Didn’t receive OTP?
                  <span [hidden]="resendLinkDisable" (click)="sendPasswordOtp()" class="resend">RESEND</span></span>
                <button [disabled]="verifyButton" class="btn btn-lg btn-theme mt-4 mb-5"
                  (click)="confirmPasswordOtp()">Verify</button>
                <div *ngIf="loading" class="spinner-border loader" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Verify OTP Modal Ends-->

<!--Create Password Modal Starts-->
<div class="modal fade auth-modal" id="create-password-modal" data-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Login.svg" class="content-image" alt="Login">
            </div>
            <div class="col-md-7 px-4 pt-3 pb-5">
              <div class="d-flex flex-column">
                <div class="navigation-arrow mb-4" (click)="navigateToLoginModal()">
                  <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
                </div>
                <span class="title mt-5">Create new password</span>
                <span class="sub-title mt-4">Please enter your new password</span>
                <span class="input-label mt-4 mb-2">Password</span>
                <div class="input-icons">
                  <i class="fas eye-icon" [ngClass]="{'fa-eye': eye, 'fa-eye-slash': !eye}" (click)="toggle()"></i>
                  <input #pass class="form-control form-control-sm header-search" placeholder="Password"
                    type="password" [(ngModel)]="newPassword">
                </div>
                <button class="btn btn-lg btn-theme mt-4 mb-5" [disabled]="newPassword.length < 6 || loading"
                 (click)="resetPassword()">Reset Password</button>
                 <div *ngIf="loading" class="spinner-border loader" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Create Password Modal Ends-->

<!--Password Reset Success Modal Starts-->
<div class="modal fade auth-modal" id="password-reset-success-modal" data-keyboard="false" tabindex="-1"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Login.svg" class="content-image" alt="Login">
            </div>
            <div class="col-md-7 px-4 pt-3 pb-5">
              <div class="d-flex flex-column">
                <div class="navigation-arrow mb-4" (click)="verifyOtpModal() ">
                  <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
                </div>
                <div class="d-flex flex-column text-center">
                  <div class="correct-icon-section mt-5">
                    <i class="fas fa-check correct-icon"></i>
                  </div>
                  <span class="title mt-3">Password reset successful</span>
                  <span class="sub-title mt-4">You have successfully reset your password.</span>
                  <span class="sub-title mt-1">Please use your new password when loggin in.</span>
                  <button class="btn btn-lg btn-theme mt-4 mb-5" (click)="navigateToLoginModal()">Login Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Password Reset Success Modal Starts-->

<!--Verify Email Mobile Modal Starts-->
<div class="modal fade auth-modal" id="verify-email-mobile-modal" data-keyboard="false" tabindex="-1"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content w-100">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 image-section">
              <img src="../../../../../assets/Images/Signup-pregnant.svg" class="content-image" alt="Login">
            </div>
            <div class="col-md-7 px-4 pt-3">
              <div class="d-flex flex-column">
                <div class="navigation-arrow mb-4" (click)="navigateToSignupForm()">
                  <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
                </div>
                <span class="title mt-2">Verify your email and mobile</span>
                <span class="sub-title-text mt-4">Please enter the 6 digit OTP received on your email
                  <strong>{{otpData?.userEmail}}</strong> and on your mobile
                  <strong>{{otpData?.userPhonenumber}}</strong></span>
                <span class="otp-header mt-4 mb-1">Email OTP</span>
                <app-otp-input #emailOtp [invalidOtp]="invalidEmail"></app-otp-input>
                <span class="no-otp-received mt-1 mb-3">Didn’t receive email OTP? <span (click)="sendEmailOTP(true)"
                    class="resend" [hidden]="emailResendLinkDisable">RESEND</span></span>
                <span class="otp-header mt-2 mb-1">Mobile OTP</span>
                <app-otp-input #phoneOtp [invalidOtp]="invalidPhoneOtp"></app-otp-input>
                <span class="no-otp-received mt-1 mb-3">Didn’t receive mobile OTP? <span (click)="sendPhoneOTP(true)"
                    class="resend" [hidden]="resendLinkDisable">RESEND</span></span>
                <button (click)="confirmSignUpOtp()" [disabled]="verifyButton"
                  class="btn btn-lg btn-theme mt-2 mb-5">Confirm & create my
                  account</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Verify Email Mobile Modal Ends-->
